// ─────────────────────────────────────────────────────────────────
// Displacement Summary Types — Matching Xamarin DTOs exactly
// ─────────────────────────────────────────────────────────────────

/** Matches Xamarin DisplacedSummaryModelDTO (individual displaced trailer row) */
export interface DisplacedSummaryItemDTO {
  trailer_name: string;
  curr_location_name: string;
  prev_location_name: string;
  time_last_moved: string;
  trailer_id: string;
}

/** Matches Xamarin DisplacedSummaryResponseModelDTO (full API response) */
export interface DisplacedSummaryResponseDTO {
  success: string;
  message: string;
  message_key: string;
  number_of_records: string;
  number_of_trailers_displaced_last_hr: string;
  top_displaced_trailer_locations_last_hr: string;
  data: DisplacedSummaryItemDTO[] | undefined;
}

/** UI model — mapped from DTO (matches Xamarin DisplacedSummaryModel) */
export interface DisplacedSummaryItem {
  TrailerName: string;
  CurrentLocation: string;
  PreviousLocation: string;
  TimeOfLastMoved: string;
  TrailerId: string;
}

/** UI model — mapped from response DTO (matches Xamarin DisplacedSummaryResponseModel) */
export interface DisplacedSummaryResponse {
  Success: string;
  StatusMessage: string;
  StatusMessageKey: string;
  NumberOfRecords: string;
  NumberOfTrailersDisplacedOneHour: string;
  TopDisplacedTrailerLocations: string;
  DisplacedSummaryModelList: DisplacedSummaryItem[];
}

/** Request body — matches Xamarin GetYardCapacityRequestDTO */
export interface DisplacedSummaryRequest {
  TraceData: {
    User: string;
    Plant: string;
    SessionId: string;
  };
}

/** Maps DTO item to UI model */
export function mapDisplacedSummaryItem(dto: DisplacedSummaryItemDTO): DisplacedSummaryItem {
  return {
    TrailerName: dto.trailer_name,
    CurrentLocation: dto.curr_location_name,
    PreviousLocation: dto.prev_location_name,
    TimeOfLastMoved: dto.time_last_moved,
    TrailerId: dto.trailer_id,
  };
}

/** Maps DTO response to UI model */
export function mapDisplacedSummaryResponse(
  dto: DisplacedSummaryResponseDTO
): DisplacedSummaryResponse {
  return {
    Success: dto.success,
    StatusMessage: dto.message,
    StatusMessageKey: dto.message_key,
    NumberOfRecords: dto.number_of_records,
    NumberOfTrailersDisplacedOneHour: dto.number_of_trailers_displaced_last_hr,
    TopDisplacedTrailerLocations: dto.top_displaced_trailer_locations_last_hr,
    DisplacedSummaryModelList: (dto.data ?? []).map(mapDisplacedSummaryItem),
  };
}
